import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when Forgot Username request is successful.
 * @memberOf Playtech.API.events
 * @event FORGOT_USERNAME_SUCCESS
 * @type {callback}
 * @example Playtech.on('FORGOT_USERNAME_SUCCESS', () => { ... });
 */
export const EVENT_FORGOT_USERNAME_SUCCESS = 'FORGOT_USERNAME_SUCCESS';
/**
 * Event fires when Forgot Username request is failed.
 * @memberOf Playtech.API.events
 * @event FORGOT_USERNAME_FAIL
 * @type {callback}
 * @example Playtech.on('FORGOT_USERNAME_FAIL', () => { ... });
 */
export const EVENT_FORGOT_USERNAME_FAIL = 'FORGOT_USERNAME_FAIL';

export const useOnForgotUsername = (eventTarget: EventTarget) => {
    const onForgotUsernameSuccess = useCallback((...args: any[]): void => {
        eventTarget.dispatchEvent(new CustomEvent(EVENT_FORGOT_USERNAME_SUCCESS, { detail: args }));
    }, [eventTarget]);

    const onForgotUsernameFail = useCallback((...args: any[]): void => {
        eventTarget.dispatchEvent(new CustomEvent(EVENT_FORGOT_USERNAME_FAIL, { detail: args }));
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('forgotUsername:success', onForgotUsernameSuccess);
        publicEventsAPIService.on('forgotUsername:fail', onForgotUsernameFail);

        return () => {
            publicEventsAPIService.off('forgotUsername:success', onForgotUsernameSuccess);
            publicEventsAPIService.off('forgotUsername:fail', onForgotUsernameFail);
        };
    }, [onForgotUsernameSuccess, onForgotUsernameFail]);
};
